<template>
  <div>
  <v-app>
      <HeaderComponent />      
    <v-main>
      <router-view/>
    </v-main>
      <FooterComponent />
  </v-app>

</div>
</template>

<script>
import HeaderComponent from '@/components/layouts/HeaderComponent.vue'
import FooterComponent from '@/components/layouts/FooterComponent.vue'


export default {
  
  name: 'App',
  
  components:
  { HeaderComponent,
    FooterComponent,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>

</style>